// extracted by mini-css-extract-plugin
export default {"overlay":"CookieConsent-module__overlay-qH4Y","slideUp":"CookieConsent-module__slideUp-K1MT"};